var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrendingUp = function SvgTrendingUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.466 6.667q.045.002.09.01l.04.01q.093.024.176.078a.6.6 0 0 1 .269.5v5.647a.6.6 0 0 1-1.2 0V8.713l-6.976 6.977a.6.6 0 0 1-.849 0l-4.282-4.283-5.693 5.694a.6.6 0 1 1-.848-.849l6.117-6.117.094-.077a.6.6 0 0 1 .755.077l4.281 4.281 6.553-6.552h-4.2a.6.6 0 1 1 0-1.199h5.648z"
  })));
};
export default SvgTrendingUp;